// @ts-nocheck

export const CashoutErrorCodes = {
  USER_NOT_CONNECTED: 1,
  CASHOUT_NOT_AVAILABLE: 1100,
  CASHOUT_VALUE_CHANGED: 1102,
  TOO_SMALL_RUNNING_AMOUNT: 1103,
};
